import {getAccountsManagers} from 'src/openapi/admin/apis/AccountManagerRelationsApi';
import {useAppDispatch} from 'src/store/hooks';

import {COLUMNS} from '../../../constants';

type Props = {
    data: Record<string, string>[],
    selectedColumns: string[],
    accountIds: number[],
    nameToIdsMap: Record<string, number>,
    apiDispatch: ReturnType<typeof useAppDispatch>,
};

export const fetchPrimaryManagers = async (props: Props): Promise<Record<string, string>[] | null> => {
    const {data, selectedColumns, accountIds, nameToIdsMap, apiDispatch} = props;

    if (!selectedColumns.includes(COLUMNS.PRIMARY_ACCOUNT_MANAGER)) {
        return data;
    }

    const response = await apiDispatch(getAccountsManagers({
        requestBody: [...new Set(accountIds)],
    }));

    if (!response.payload.success) {
        return null;
    }

    const managers = response.payload.data;

    return data.map(row => {
        const accountId = nameToIdsMap[row[COLUMNS.ACCOUNT_NAME]];
        const manager = managers[accountId];

        const label = [manager?.firstName, manager?.lastName].filter(Boolean).join(' ') || manager?.email || '--';

        return {
            ...row,
            [COLUMNS.PRIMARY_ACCOUNT_MANAGER]: label,
        };
    });
};
